<template>
  <FormGroup
    type="ajax-select"
    label-method="name"
    :id-only="true"
    :fetch-models="fetchModels"
    :fetch-options="fetchOptions"
  >
    <template #label="{ selected }">
      <a v-if="selected" class="link" @click.stop="openModal(selected.id)"> Insurer </a>
      <template v-else> Insurer </template>
      <CarrierShowModal ref="ModalRef" />
    </template>
    <template #controls="{ selected }">
      <a v-if="selected?.url" class="link" :href="selected.url" target="_blank">Website</a>
    </template>
  </FormGroup>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import CarrierApi from '@/js/Api/Carrier';
import CarrierShowModal from '@/js/Components/Carriers/ShowModal.vue';
import FormGroup from '@/js/Components/Form/FormGroup.vue';

const fetchModels = (id: number[]) => {
  return CarrierApi.all({
    queryBuilder: {
      filters: {
        id,
      },
    },
  });
};

const fetchOptions = (query: string | undefined, page: number) => {
  return CarrierApi.index({
    queryBuilder: {
      page,
      filters: {
        name: query,
      },
    },
  });
};

const ModalRef = ref<InstanceType<typeof CarrierShowModal> | null>(null);
const openModal = (id: number) => {
  if (!ModalRef.value) return;
  ModalRef.value.open(id);
};
</script>
